<template>
	<div class="siteSeoAnalysis">
		<div class="top">
			<div class="top_text">
				<div>网站SEO分析</div>
				<!-- 网址切换 -->
				<sky-dropdown-select
					class="site-list"
					@change="changeSite"
					v-model="siteId"
					:options="websiteList"
					:props="{ label: 'name', value: 'id' }"
				></sky-dropdown-select>
			</div>
			<el-button type="primary" @click="refresh" v-if="showStatus === 1 || showStatus === 2"
				>重新分析</el-button
			>
		</div>
		<div class="data_body" v-if="showStatus === 2">
			<div class="data_item" v-for="item in details" :key="item.name">
				<div class="data_top">
					<div class="data_icon">
						<ig-icon name="shouye"></ig-icon>
					</div>
					<span class="name">{{ item.name }}</span>
					<span class="tips">{{ item.tips }}</span>
				</div>
				<div class="data_bottom" v-if="!item.components">
					<div v-if="item.status" class="data_content">
						<i class="icon el-icon-success" />
						<div class="content">{{ item.suc }}</div>
					</div>
					<div v-else class="data_content">
						<i class="icon el-icon-error" />
						<div class="content_err">{{ item.err }}</div>
					</div>
				</div>
				<component v-else :is="item.components" :data="item.data" :scope="item"></component>
			</div>
		</div>

		<statusPage v-else :showStatus="showStatus" @refresh="refresh"></statusPage>
	</div>
</template>

<script>
import siteSeoAnalysisSer from '@/backend/services/siteSeoAnalysis/siteSeoAnalysisSer.js';
import setting from './setting.js';
// import mixinsWatch from '@/client/mixinsWatch/mixinsWatch';
import statusPage from './components/statusPage.vue';
import { getWebsiteByCustomer } from '@/backend/services/account/service';
import { mapGetters } from 'vuex';
import skyDropdownSelect from '@/components/iglobalwin/formComponents/sky-dropdownSelect';

function replaceFields(str, obj) {
	// 匹配 ${fieldName} 的正则表达式
	var regex = /\${(.*?)}/g;

	// 使用 replace() 方法替换字段
	var replacedStr = str.replace(regex, function (match, fieldName) {
		return obj[fieldName] || match;
	});

	return replacedStr;
}

export default {
	name: 'siteSeoAnalysis',
	components: {
		statusPage,
		skyDropdownSelect,
	},
	// mixins: [mixinsWatch],
	data() {
		return {
			siteId: '',
			domain: '--',
			websiteList: [],
			timer: null, // 定时器
			details: [],
			resultsId: '',
			showStatus: 4, // 状态 (0:网站未上线  1:检测中  2:成功  3:失败  4:未分析)
			refreshStatus: false,
		};
	},
	destroyed() {
		if (this.timer) window.clearInterval(this.timer);
	},
	computed: {
		...mapGetters(['customerId']),
	},
	watch: {
		customerId: {
			async handler(val) {
				if (val) this.getWebsite();
				else this.$message.warning('您需要先选择一个客户');
			},
			immediate: true,
			deep: true,
		},
	},
	methods: {
		init() {
			// let { activeWebsite } = this;
			// let { upLineStatus } = activeWebsite;
			if (this.timer) window.clearInterval(this.timer);
			// if (upLineStatus !== 1) {
			// 	this.showStatus = 0;
			// 	return;
			// }
			this.siteSeoAnalysisMySiteReport();
		},
		// 网站下拉数据
		async getWebsite() {
			try {
				let { customerId } = this;
				let result = await getWebsiteByCustomer({
					customerId,
				});
				this.websiteList = result.data;
				if (result.data.length == 0) return false;
				this.siteId = result.data[0].id;
				this.domain = result.data[0].name;
				this.init();
			} catch (error) {
				console.log(error);
			}
		},
		// 网址选择切换
		changeSite(id) {
			let obj = this.websiteList.find(item => {
				return item.id === id;
			});
			this.domain = obj.name;
			this.init();
		},
		// 获取我的网站报告
		async siteSeoAnalysisMySiteReport() {
			if (this.timer) window.clearInterval(this.timer);
			let { siteId: serviceSiteId } = this;
			let res = await siteSeoAnalysisSer.siteSeoAnalysisMySiteReport({
				serviceSiteId,
			});
			if (res) {
				if (!res?.data?.id) {
					this.showStatus = 4;
					return;
				}
				if (res.data.testStatus === 1) {
					this.resultsId = res.data.id;
					this.start();
				}
				this.judgeState(res.data);
			}
		},
		refresh() {
			if (this.refreshStatus) return;
			this.refreshStatus = true;
			this.showStatus = 1;
			this.start();
		},
		// 开始检测 并轮询检测结果接口
		async start() {
			try {
				if (this.timer) window.clearInterval(this.timer);
				let { siteId: serviceSiteId } = this;
				let res = await siteSeoAnalysisSer.siteSeoAnalysisStart({
					serviceSiteId,
				});
				if (res) {
					this.resultsId = res.data;
					await this.getResults();
					this.timer = window.setInterval(() => {
						window.setTimeout(this.getResults, 0);
					}, 3000);
				}
			} catch (error) {
				this.refreshStatus = false;
				this.showStatus = 0;
			}
		},
		// 获取检测详情
		async getResults() {
			let { siteId: serviceSiteId } = this;
			let res = await siteSeoAnalysisSer.siteSeoAnalysisMySiteReport({
				serviceSiteId,
			});
			if (res) {
				let { data } = res;
				if (data.testStatus !== 1) {
					this.judgeState(data);
					window.clearInterval(this.timer);
				}
			}
		},
		// 状态判断
		judgeState(data) {
			let { testStatus } = data;
			this.refreshStatus = false;
			this.dataProcessing(data);
			this.showStatus = testStatus;
		},
		// 数据处理
		dataProcessing(val) {
			let data = [];
			let { titleLength, descriptionLength } = val;
			if (titleLength > 65) {
				val.titleTips = '超过了';
				val.titleNum = 65;
			}
			if (titleLength < 50) {
				val.titleTips = '少于';
				val.titleNum = 50;
			}
			if (descriptionLength > 160) {
				val.descriptionTips = '超过了';
				val.descriptionNum = 160;
			}
			if (descriptionLength < 150) {
				val.descriptionTips = '少于';
				val.descriptionNum = 150;
			}
			setting.forEach(item => {
				let { fun, dataFun, suc, err } = item;
				if (fun) item.status = fun(val);
				if (dataFun) item.data = dataFun(val);
				if (suc) item.suc = replaceFields(suc, val);
				if (err) item.err = replaceFields(err, val);
				data.push(item);
			});
			this.details = data;
		},
	},
};
</script>

<style lang="scss" scoped>
.siteSeoAnalysis {
	.top {
		display: flex;
		align-items: center;
		justify-content: space-between;
		background-color: #fff;
		margin: 0px 20px 10px;
		padding: 10px 20px;
		border-radius: 6px;
		height: 60px;

		.top_text {
			font-size: 16px;
			font-weight: 600;
			color: #333333;

			display: flex;
			justify-content: center;
			align-items: center;

			.site-list {
				margin-left: 10px;
			}
		}
	}

	.data_body {
		margin: 0px 20px;
		background-color: #fff;
		.data_item {
			width: 100%;
			.data_top {
				height: 50px;
				background: #f2f2f2;
				display: flex;
				align-items: center;
				padding-left: 20px;

				.data_icon {
					background: #0088d1;
					width: 28px;
					height: 28px;
					border-radius: 50%;
					display: flex;
					justify-content: center;
					align-items: center;
					margin-right: 10px;

					.iconfont {
						font-size: 20px;
						color: #fff;
					}
				}

				.name {
					font-size: 15px;
					font-weight: 600;
					color: #333333;
				}

				.tips {
					font-size: 13px;
					margin-left: 15px;
					color: #4d4c4c;
				}
			}

			.data_bottom {
				.data_content {
					display: flex;
					align-items: center;
					padding: 50px 20px 50px 30px;

					.icon {
						font-size: 18px;
					}

					.el-icon-success {
						color: #2abd2c;
					}

					.el-icon-error {
						color: #ff0b0b;
					}

					.content,
					.content_err {
						margin-left: 10px;
						white-space: pre-line;
					}

					.content_err {
						color: #ff0b0b;
					}
				}
			}
		}
	}
}
</style>
